// TODO: Candidate to shuffle into the base perhaps.
// Like InputText, but only allows limited data entry, based
// on a regexp pattern (like text only, alphanum only).
// Provides a visual "wiggle" effect when an invalid is attempted (and stops it).
import * as React from 'react'
import { BaseInputProps, InputText } from '@paytrace/pt-skel/Component'

interface Props extends BaseInputProps {
  strip?: string,
  pattern?: string,
}

export function PatternGuardedInputText (props: Props) {
  // Should roughly match the back end, perhaps more restrictive
  const { strip, pattern, onChange } = props
  const rx = new RegExp(pattern || '.*')

  // We only want the allowed key patterns, so if user sends
  // some that are not allowed, just ignore them.
  const patternGuard = (e: React.ChangeEvent<HTMLInputElement>) => {
    // The strip support is a convenient way to let pasting of common
    // superflous data (a formatted credit card or phone)
    if (strip) {
      const rxStrip = new RegExp(strip, 'g')
      e.target.value = e.target.value.replace(rxStrip, '')
    }

    if (rx.test(e.target.value) && onChange) {
      return onChange(e)
    }

    // FIXME: There is probably a "better" way to implement a general "shake" effect,
    // using CSS transitions, but this will do as a quick impl. (it actually looks
    // quite good and not terribly jarring), or using the Form Validation framework.
    e.target.style.marginLeft = '-3px'

    setTimeout(() => { e.target.style.marginLeft = '6px' }, 25)
    setTimeout(() => { e.target.style.marginLeft = '-6px' }, 50)
    setTimeout(() => { e.target.style.marginLeft = '3px' }, 75)
    setTimeout(() => {
      e.target.style.marginLeft = '0px'
    }, 100)
  }

  return <InputText {...props} onChange={patternGuard} />
}
